import JsSIP from 'jssip';
import AxiosConfig from '../../../config/AxiosConfig';
import socketService from './socketService';

let jsSipUserAgent = null;
const freepbxIP = import.meta.env.VITE_FREEPBX_IP;
const freepbxPort = import.meta.env.VITE_FREEPBX_PORT;

export const jssipuaInit = async (profile) => {
  if (
    !jsSipUserAgent &&
    import.meta.env.VITE_HOORTEL_ENABLED === 'true' &&
    profile?.sipExtension &&
    profile?.sipPassword
  ) {
    const wsServer = `wss://${freepbxIP}:${freepbxPort}/ws`;

    try {
      const socket = new JsSIP.WebSocketInterface(wsServer);

      const configuration = {
        sockets: [socket],
        authorization_user: `${profile.sipExtension}`,
        uri: `sip:${profile.sipExtension}@${freepbxIP}`,
        ws_servers: wsServer,
        password: `${profile.sipPassword}`,
        realm: `${freepbxIP}`,
        display_name: `${profile.firstName} ${profile.lastName}`,
        contact_uri: `sip:${profile.sipExtension}@${freepbxIP}`,
        register: true,
      };

      jsSipUserAgent = new JsSIP.UA(configuration);

      jsSipUserAgent?.on('connecting', (e) => {
        console.log('UA connecting', e);
      });

      jsSipUserAgent?.on('connected', (e) => {
        console.log('UA connected', e);
      });

      jsSipUserAgent?.on('disconnected', (e) => {
        console.log('UA disconnected', e);
      });

      jsSipUserAgent?.on('registered', (e) => {
        console.log('UA registered', e);
      });

      jsSipUserAgent?.on('unregistered', (e) => {
        console.log('UA unregistered', e);
      });

      jsSipUserAgent?.on('registrationFailed', (e) => {
        console.log('UA registrationFailed', e);
      });

      jsSipUserAgent?.on('registrationExpiring', (e) => {
        console.log('UA registrationExpiring', e);
      });

      jsSipUserAgent?.on('newMessage', (e) => {
        console.log('UA newMessage', e);
      });

      // jsSipUserAgent?.on("newOptions", (e) => {
      //   console.log("UA newOptions", e);
      // });

      jsSipUserAgent?.on('sipEvent', (e) => {
        console.log('UA sipEvent', e);
      });

      jsSipUserAgent?.on('newRTCSession', (e) => {
        console.log('UA newRTCSession', e);
      });

      jsSipUserAgent?.start();
    } catch (e) {
      console.log('JSSIPUserAgent Error : ', e);
    }
  }
};

export const jssipuaStop = () => {
  if (!jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.stop();
  }
};

export const jssipuaRegister = () => {
  if (jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.register();
  }
};

export const jssipuaUnregister = () => {
  if (jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.unregister();
  }
};

export const jssipuaIsRegistered = () => {
  if (jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.isRegistered();
  }
};

export const jssipuaIsConnected = () => {
  if (jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.isConnected();
  }
};

export const jssipuaTerminateSessions = () => {
  if (jsSipUserAgent && import.meta.env.VITE_HOORTEL_ENABLED === 'true') {
    return jsSipUserAgent?.terminateSessions();
  }
};

export const sessionInitCall = (
  profile,
  phoneNumber,
  ticketId,
  setSession,
  mutateTicket,
  onPhoneCallCreated
) => {
  if (
    jsSipUserAgent?.isRegistered() &&
    import.meta.env.VITE_HOORTEL_ENABLED === 'true' &&
    profile
  ) {
    const playAudio = async (audioElement) => {
      if (audioElement.paused) {
        // Vérifie si l'audio est déjà en lecture
        try {
          await audioElement.play(); // Essaie de lancer la lecture
          console.log('Audio is playing');
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Audio play failed:', error);
          }
        }
      } else {
        console.log('Audio is already playing');
      }
    };

    const remoteAudio = document.createElement('audio');
    let phonecall = null;

    const eventHandlers = {
      connecting: (e) => {
        console.log('session connecting', e);
        socketService.emit('userStatusChanged', {
          userId: profile._id,
          status: 'busy',
        });
        AxiosConfig.create('post', '/phonecalls/')
          .call({
            userId: profile?._id,
            phoneNumber: phoneNumber,
            ticketId: ticketId,
          })
          .exit((res) => {
            phonecall = res?.data;
            onPhoneCallCreated?.(res?.data?._id);
          })
          .catch((err) => console.error(err))
          .finally(() => {
            mutateTicket();
          });
        if ('srcObject' in remoteAudio) {
          const remoteStream = session.connection.getRemoteStreams()[0];
          if (remoteStream && remoteAudio.srcObject !== remoteStream) {
            remoteAudio.srcObject = remoteStream;
          }
        } else {
          const remoteStream = session.connection.getRemoteStreams()[0];
          remoteAudio.src = window.URL.createObjectURL(remoteStream);
        }
        remoteAudio.addEventListener('canplay', () => {
          playAudio(remoteAudio);
        });
        remoteAudio.addEventListener('loadeddata', () => {
          playAudio(remoteAudio);
        });
      },
      sending: (e) => {
        console.log('session sending', e);
        if ('srcObject' in remoteAudio) {
          const remoteStream = session.connection.getRemoteStreams()[0];
          if (remoteStream && remoteAudio.srcObject !== remoteStream) {
            remoteAudio.srcObject = remoteStream;
          }
        } else {
          const remoteStream = session.connection.getRemoteStreams()[0];
          remoteAudio.src = window.URL.createObjectURL(remoteStream);
        }
        remoteAudio.addEventListener('canplay', () => {
          playAudio(remoteAudio);
        });
        remoteAudio.addEventListener('loadeddata', () => {
          playAudio(remoteAudio);
        });
      },
      progress: (e) => {
        console.log('session progress', e);
        if ('srcObject' in remoteAudio) {
          const remoteStream = session.connection.getRemoteStreams()[0];
          if (remoteStream && remoteAudio.srcObject !== remoteStream) {
            remoteAudio.srcObject = remoteStream;
          }
        } else {
          const remoteStream = session.connection.getRemoteStreams()[0];
          remoteAudio.src = window.URL.createObjectURL(remoteStream);
        }
        remoteAudio.addEventListener('canplay', () => {
          playAudio(remoteAudio);
        });
        remoteAudio.addEventListener('loadeddata', () => {
          playAudio(remoteAudio);
        });
      },
      accepted: (e) => {
        console.log('session accepted', e);
        if ('srcObject' in remoteAudio) {
          const remoteStream = session.connection.getRemoteStreams()[0];
          if (remoteStream && remoteAudio.srcObject !== remoteStream) {
            remoteAudio.srcObject = remoteStream;
          }
        } else {
          const remoteStream = session.connection.getRemoteStreams()[0];
          remoteAudio.src = window.URL.createObjectURL(remoteStream);
        }
        remoteAudio.addEventListener('canplay', () => {
          playAudio(remoteAudio);
        });
        remoteAudio.addEventListener('loadeddata', () => {
          playAudio(remoteAudio);
        });
      },
      confirmed: (e) => {
        console.log('session confirmed', e);

        AxiosConfig.create('put', `/phonecalls/${phonecall?._id}/confirmed`)
          .call({})
          .exit((res) => {
            phonecall = res?.data;
          })
          .catch((err) => console.error(err))
          .finally(() => {
            mutateTicket();
          });

        if ('srcObject' in remoteAudio) {
          const remoteStream = session.connection.getRemoteStreams()[0];
          if (remoteStream && remoteAudio.srcObject !== remoteStream) {
            remoteAudio.srcObject = remoteStream;
          }
        } else {
          const remoteStream = session.connection.getRemoteStreams()[0];
          remoteAudio.src = window.URL.createObjectURL(remoteStream);
        }
        remoteAudio.addEventListener('canplay', () => {
          playAudio(remoteAudio);
        });
        remoteAudio.addEventListener('loadeddata', () => {
          playAudio(remoteAudio);
        });
      },
      addstream: (e) => {
        console.log('session addstream', e);
      },
      ended: (e) => {
        console.log('session ended', e);
        socketService.emit('userStatusChanged', {
          userId: profile._id,
          status: 'active',
        });

        AxiosConfig.create('put', `/phonecalls/${phonecall?._id}/ended`)
          .call({
            originator: e.originator,
          })
          .exit((res) => {
            phonecall = res?.data;
            onPhoneCallCreated?.(null);
          })
          .catch((err) => console.error(err))
          .finally(() => {
            setSession(null);
            mutateTicket();
          });
      },
      failed: (e) => {
        console.log('session failed', e);
        socketService.emit('userStatusChanged', {
          userId: profile._id,
          status: 'active',
        });
        AxiosConfig.create('put', `/phonecalls/${phonecall?._id}/failed`)
          .call({
            originator: e.originator,
          })
          .exit((res) => {
            phonecall = res?.data;
            onPhoneCallCreated?.(null);
          })
          .catch((err) => console.error(err))
          .finally(() => {
            setSession(null);
            mutateTicket();
          });
      },
      newDTMF: (e) => {
        console.log('session newDTMF', e);
      },
      newInfo: (e) => {
        console.log('session newInfo', e);
      },
      hold: (e) => {
        console.log('session hold', e);
      },
      unhold: (e) => {
        console.log('session unhold', e);
      },
      muted: (e) => {
        console.log('session muted', e);
      },
      unmuted: (e) => {
        console.log('session unmuted', e);
      },
      reinvite: (e) => {
        console.log('session reinvite', e);
      },
      update: (e) => {
        console.log('session update', e);
      },
      refer: (e) => {
        console.log('session refer', e);
      },
      replaces: (e) => {
        console.log('session replaces', e);
      },
      sdp: (e) => {
        console.log('session sdp', e);
      },
      icecandidate: (e) => {
        console.log('session icecandidate', e);
      },
      getusermediafailed: (e) => {
        console.log('session getusermediafailed', e);
      },
      peerconnection: (e) => {
        console.log('session peerconnection', e);
      },
      'peerconnection:createofferfailed': (e) => {
        console.log('session peerconnection:createofferfailed', e);
      },
      'peerconnection:createanswerfailed': (e) => {
        console.log('session peerconnection:createandwerfailed', e);
      },
      'peerconnection:setlocaldescriptionfailed': (e) => {
        console.log('session peerconnection:setlocaldescriptionfailed', e);
      },
      'peerconnection:setremotedescriptionfailed': (e) => {
        console.log('session peerconnection:setremotedescriptionfailed', e);
      },
    };

    const options = {
      eventHandlers: eventHandlers,
      mediaConstraints: { audio: true, video: false },
    };

    const session = jsSipUserAgent?.call(
      `sip:${phoneNumber}@${freepbxIP}`,
      options
    );

    return session;
  }
};

export const sessionTerminate = (session, reason, mutateTicket) => {
  console.log('SESSION TERMINATE');
  if (
    jsSipUserAgent?.isRegistered() &&
    import.meta.env.VITE_HOORTEL_ENABLED === 'true' &&
    session &&
    !session.isEnded()
  ) {
    return session.terminate(reason);
  }
  mutateTicket();
};

export const sessionSendDTMF = (session, dtmf) => {
  return session.sendDTML(dtmf);
};

export const sessionHold = (session) => {
  return session.hold();
};

export const sessionUnhold = (session) => {
  return session.unhold();
};

export const sessionMute = (session) => {
  return session.mute();
};

export const sessionGetRemoteStream = (session) => {
  return session.getRemoteStream();
};

export const sessionIsOnHold = (session) => {
  return session.isOnHold();
};

export const sessionIsOnMute = (session) => {
  return session.isMuted();
};
